import AppConstants from '../config/app.constants';

let TruckService = function ($http, $q) {

    let all = (search, offset, limit) => {
        return $http
            .get(AppConstants.api + `/vehicle`, {
                params: {
                    search,
                    offset,
                    limit
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let create = (data, branchId) => {
        return $http
            .post(AppConstants.api + `/vehicle/create`, { data, branchId })
            .then((res) => {
                return res.data
            })
    }

    let remove = (id, branchId) => {
        return $http
            .delete(AppConstants.api + `/vehicle/${id}`, {
                params: {
                    branchId
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let update = (id, data, branchId) => {
        return $http
            .post(AppConstants.api + `/vehicle/${id}`, { data, branchId })
            .then((res) => {
                return res.data
            })
    }

    let get = (id) => {
        return $http
            .get(AppConstants.api + `/vehicle/${id}`)
            .then((res) => {
                return res.data
            })
    }

    let setTruckForRoute = (id, route, date, branchId) => {
        return $http
            .post(AppConstants.api + `/vehicle/${id}/set-truck`, {
                route,
                date,
                branchId
            })
            .then((res) => {
                return res.data
            })
    }

    let getAllTrucks = (searchText, branch, routeId, vaultDate, limit, offset) => {
        return $http
            .get(AppConstants.api + `/vehicle/multi-branch-truck`, {
                params: {
                    searchText, branch, routeId, vaultDate, limit, offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    let loadRemainingTrucks = (branch, locationType) => {
        return $http
            .get(AppConstants.api + `/vehicle/load-remaining-trucks`, {
                params: {
                    branch,
                    locationType
                }
            })
            .then((res) => {
                return res.data
            })
    };

    let getRestrictTrucks = (searchText, branch, routeId, limit, offset) => {
        return $http
            .get(AppConstants.api + `/vehicle/get-restrict-trucks`, {
                params: {
                    searchText, branch, routeId, limit, offset
                }
            })
            .then((res) => {
                return res.data
            })
    }

    return {
        all,
        create,
        remove,
        update,
        get,
        setTruckForRoute,
        getAllTrucks,
        loadRemainingTrucks,
        getRestrictTrucks
    };
};

TruckService.$inject = ['$http', '$q']

export default TruckService;


// WEBPACK FOOTER //
// ./client/app/services/truck.service.js